import type { ChartService } from "./historical-chart.service";
import { type StablecoinLatestDO } from "../data/pie-chart.data";

export class TableChartService {
  constructor(private chartService: ChartService) { }

  async loadStablecoinsLatest(): Promise<StablecoinLatestDO> {
    return this.chartService.load('latest/stablecoins');
  }
}
